// extracted by mini-css-extract-plugin
export default {"logo":"In9Pu","newsroomSelectDialog":"SEsVc","dialogHeading":"RO7dN"};